import { Component } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { HomeButtonComponent } from 'app/modules/scootaverse/components/home-button/home-button.component';

import { MediaEmbedType } from '../../services/presentation/presentation.service';

@Component({
  selector: 'app-presentation-embed-modal',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    HomeButtonComponent,
  ],
  templateUrl: './presentation-embed-modal.component.html',
  styleUrl: './presentation-embed-modal.component.scss',
})
export class PresentationEmbedModalComponent {
  public constructor(private dialogRef: MatDialogRef<PresentationEmbedModalComponent>) {}

  protected mediaTypeOptions = [{ name: 'Vimeo', value: MediaEmbedType.VIMEO }];
  protected selectedEmbed: string = MediaEmbedType.VIMEO;

  // vimeo specific
  protected vimeoControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/vimeo.com\/[0-9]+/),
  ]);
  protected vimeoMatcher: ErrorStateMatcher = new ErrorStateMatcher();
  // TODO: youtube specific

  protected submit() {
    this.dialogRef.close({ mediaEmbedType: this.selectedEmbed, embedCode: this.vimeoControl.value });
  }

  protected cancel() {
    this.dialogRef.close(null);
  }
}
